module.exports = __webpack_public_path__ + "media/logos/msnbc-logo-black-b8d15c8c.png";